import type { MessageKey } from 'types/LocaleMessageKey';

import type { BaseStoreRingData } from '../_types/types';

export const getOr4CeramicDataArray = (
  isMidnightExclusive: boolean,
): BaseStoreRingData[] => {
  const _subcopy = isMidnightExclusive
    ? { subcopy: 'exclusive_cap' as MessageKey }
    : undefined;
  return [
    {
      productKey: 'OuraRing4CerMidnight',
      productImg: {
        src: 'jade-pop/midnight-front-view',
        alt: 'jade_midnight_product_img_alt',
      },
      lifeStyleImg: {
        src: 'store/ring-carousels/hover-images/or4c-midnight',
        alt: 'jade_pdp_midnight_primary_image_alt',
      },
      finish: 'midnight',
      pdpPath: '/store/rings/oura-ring-4-ceramic/midnight',
      ..._subcopy,
    },
    {
      productKey: 'OuraRing4CerCloud',
      productImg: {
        src: 'jade-pop/cloud-front-view',
        alt: 'jade_cloud_product_img_alt',
      },
      lifeStyleImg: {
        src: 'store/ring-carousels/hover-images/or4c-cloud',
        alt: 'jade_pdp_cloud_primary_image_alt',
      },
      finish: 'cloud',
      pdpPath: '/store/rings/oura-ring-4-ceramic/cloud',
    },
    {
      productKey: 'OuraRing4CerPetal',
      productImg: {
        src: 'jade-pop/petal-front-view',
        alt: 'jade_petal_product_img_alt',
      },
      lifeStyleImg: {
        src: 'store/ring-carousels/hover-images/or4c-petal',
        alt: 'jade_pdp_petal_primary_image_alt',
      },
      finish: 'petal',
      pdpPath: '/store/rings/oura-ring-4-ceramic/petal',
    },
    {
      productKey: 'OuraRing4CerTide',
      productImg: {
        src: 'jade-pop/tide-front-view',
        alt: 'jade_tide_product_img_alt',
      },
      lifeStyleImg: {
        src: 'store/ring-carousels/hover-images/or4c-tide',
        alt: 'jade_pdp_tide_primary_image_alt',
      },
      finish: 'tide',
      pdpPath: '/store/rings/oura-ring-4-ceramic/tide',
    },
  ];
};
